export default {"src":"/planos/_next/static/media/equifax-letter.de674220.svg","height":40,"width":58,"blurWidth":0,"blurHeight":0};